import styled from 'styled-components';
import { TextButton, ButtonText } from '@prisjakt/ui/button/variants';

export const HelpfulText = styled(ButtonText)``;

type HelpfulButtonProps = {
  liked: boolean;
};

export const Button = styled(TextButton)<HelpfulButtonProps>`
  ${HelpfulText} {
    overflow: hidden;
    transition: max-width 150ms ease;
    max-width: ${p => (p.liked ? 0 : '999px')};
    white-space: nowrap;
  }
`;
